/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { AuthProvider } from './shared/contexts/AuthContext';
import { AppSwitch } from './AppSwitch';
import { PurchasesProvider } from './shared/contexts/PurchasesContext';
import './index.css';

// Clean up any service workers and cache storage on native platforms to prevent WebView caching issues
if (Capacitor.isNativePlatform()) {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
        console.log('[ServiceWorker] Unregistered service worker for native platform:', registration);
      }
    }).catch((err) => {
      console.error('[ServiceWorker] Failed to get/unregister service workers:', err);
    });
  }

  if (window.caches) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
        console.log('[Cache] Deleted cache storage key:', key);
      });
    }).catch((err) => {
      console.error('[Cache] Failed to clear caches:', err);
    });
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <PurchasesProvider>
        <AppSwitch />
      </PurchasesProvider>
    </AuthProvider>
  </React.StrictMode>,
);
